module.exports = __webpack_public_path__ + "img/5tieMov.aac1c769.png";